export default {
  strings: {
    pluginNameUnsplash: 'Unsplash'
  }
};